import { render, staticRenderFns } from "./ConsultaDinamica.vue?vue&type=template&id=19bd6cdf&scoped=true"
import script from "./ConsultaDinamica.vue?vue&type=script&lang=js"
export * from "./ConsultaDinamica.vue?vue&type=script&lang=js"
import style0 from "./ConsultaDinamica.vue?vue&type=style&index=0&id=19bd6cdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bd6cdf",
  null
  
)

export default component.exports